export default {
  phone: '',
  app_name: '',
  token: '',
  initial_message: ''
}
